import { render, staticRenderFns } from "./TCMDosageDialog.vue?vue&type=template&id=4594622a&scoped=true"
import script from "./TCMDosageDialog.vue?vue&type=script&lang=js"
export * from "./TCMDosageDialog.vue?vue&type=script&lang=js"
import style0 from "./TCMDosageDialog.vue?vue&type=style&index=0&id=4594622a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4594622a",
  null
  
)

export default component.exports